import type { Tables } from "@packages/db/schema";
import type { PgTableWithColumns } from "drizzle-orm/pg-core";

export type TableIdentifier = {
  [K in keyof Tables]: Tables[K] extends PgTableWithColumns<infer U>
    ? `${U["schema"] extends string ? U["schema"] : "public"}.${U["name"]}`
    : never;
}[keyof Tables & string];

export type FieldIndentifier = {
  [K in keyof Tables]: Tables[K] extends PgTableWithColumns<infer U>
    ? `${U["schema"] extends string ? U["schema"] : "public"}.${U["name"]}.${keyof U["columns"] & string}`
    : never;
}[keyof Tables & string];

export type FilterIdentifiersByTable<TTable extends TableIdentifier> = Extract<FieldIndentifier, `${TTable}.${string}`>;

export type ExtractFieldNames<TTable extends TableIdentifier> =
  FilterIdentifiersByTable<TTable> extends `${TTable}.${infer TField}` ? TField : never;

export function parseTableIdentifier(id: TableIdentifier) {
  const parts = id.split(".");
  if (parts.length !== 2) throw new Error(`Invalid table identifier: "${id}"`);
  const [schemaName, tableName] = parts;
  return { schemaName, tableName };
}

export function parseFieldIdentifier(field: FieldIndentifier) {
  const parts = field.split(".");
  if (parts.length !== 3) throw new Error(`Invalid field identifier: "${field}"`);
  const [schemaName, tableName, fieldName] = parts;
  return { schemaName, tableName, fieldName };
}
